import { useCallback, useState } from "react";
import { Card, CardBody, CardHeader, Col, Container, Form, Input, InputGroup, InputGroupText, Row } from "reactstrap";
import { SearchPages, SearchButton, SearchWebsite } from "../../../constants";
import SearchLists from "./SearchLists";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import SearchTabsContent from "./searchTabsContent";

const SearchResultContainer = () => {
  const [activeTab, setActiveTab] = useState(1);
  const callback = useCallback((tab: number) => setActiveTab(tab), []);

  return (
    <>
      <Breadcrumbs mainTitle={SearchWebsite} parent={SearchPages} />
      <Container fluid className="search-page">
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <Form className="theme-form">
                  <InputGroup className="m-0 flex-nowrap">
                    <Input className="form-control-plaintext" type="search" placeholder="Search .." />
                    <InputGroupText className="btn btn-primary">{SearchButton}</InputGroupText>
                  </InputGroup>
                </Form>
              </CardHeader>
              <CardBody>
                <SearchLists callbackActive={callback} activeTabValue={1} />
                <SearchTabsContent activeTab={activeTab} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SearchResultContainer;
